import { useCallback, useEffect, useState } from "react";
import { api, TOKEN_KEY } from "@/lib/api";

/** Status of the "Kom i gang" setup (6 steps). Shared by the wizard, the dashboard card and the sidebar.
    One module-level cache + in-flight de-duplication so several subscribers cost one request. */
let cache = null;
let inflight = null;
const listeners = new Set();
const publish = (v) => { cache = v; listeners.forEach((fn) => fn(v)); };

export async function loadSetup() {
  if (!localStorage.getItem(TOKEN_KEY)) throw new Error("Not signed in");
  if (!inflight) {
    inflight = api.get("/org/setup").then((r) => { publish(r.data); return r.data; }).finally(() => { inflight = null; });
  }
  return inflight;
}

export async function markSetupStep(key, status) {
  const r = await api.post(`/org/setup/steps/${key}`, { status });
  publish(r.data);
  return r.data;
}

export async function dismissSetup(dismissed = true) {
  const r = await api.post("/org/setup/dismiss", { dismissed });
  publish(r.data);
  return r.data;
}

/** The wizard was opened — the one-time auto-prompt stops; the dashboard card takes over. */
export async function markSetupSeen() {
  const r = await api.post("/org/setup/seen");
  publish(r.data);
  return r.data;
}

/** Forget the cached status (sign-out, sign-in, workspace switch) so the next subscriber refetches. */
export function resetSetupCache() { publish(null); }

export function useSetup(auto = true) {
  const [status, setStatus] = useState(cache);
  const [error, setError] = useState(null);
  useEffect(() => {
    listeners.add(setStatus);
    return () => listeners.delete(setStatus);
  }, []);
  const refresh = useCallback(() => loadSetup().catch((e) => setError(e)), []);
  useEffect(() => { if (auto && status == null) refresh(); }, [auto, status, refresh]);
  return { status, error, refresh };
}
